export default __webpack_public_path__ + "static/media/chat.0549c22a.svg";